import { HTTP } from '@/http/http-client';

const logIn = payload =>
    HTTP.post(`no-auth/login`, payload).then(({ data }) => data);

const logout = () =>
    HTTP.delete(`logout`).then(({ data }) => data);

const refreshToken = payload =>
    HTTP.post(`no-auth/refresh-token`, payload).then(({ data }) => data);

const facebookAuthentication = () =>
    HTTP.get(`no-auth/facebook/login`).then(({ data }) => data);

const googleAuthentication = () =>
    HTTP.get(`no-auth/google/login/slug`).then(({ data }) => data);

const getSchoolInfo = () =>
    HTTP.get(`no-auth/schools/slug/parent-portal`).then(({ data }) => data);

const getSchoolCountryForSignUp = () =>
    HTTP.get(`no-auth/schools/slug/country`).then(({ data }) => data);

export default {
    logIn,
    logout,
    refreshToken,
    facebookAuthentication,
    googleAuthentication,
    getSchoolInfo,
    getSchoolCountryForSignUp
};


// WEBPACK FOOTER //
// ./src/http/services/authenticationService.js